import { getCheckoutDisplayAmount } from '../utils/getDisplayAmount';
import { useSafeSelector } from './useSafeSelector';

export function useCheckoutDisplayAmount(paymentMethodType?: string | null) {
  const intentionData = useSafeSelector((state: any) => state.intention);
  const selectedPaymentType = useSafeSelector(
    (state: any) => state.payment?.type
  );

  return getCheckoutDisplayAmount(
    intentionData,
    paymentMethodType ?? selectedPaymentType
  );
}
